<script lang="ts" setup>
	defineProps<{
		label?: string
		iconName?: string
		iconDir?: string
		iconPathClass?: string
	}>()
</script>

<template>
	<div class="my-4 flex h-[54px] w-full items-center gap-4 rounded bg-[#ECF8F5] px-4">
		<lazy-tools-icon :dir="iconDir as string" :icon="iconName as string" :height="20" :path-class="iconPathClass" />
		<span class="text-sm font-medium text-gray-700">{{ label }}</span>
	</div>
</template>
